module.exports = __webpack_public_path__ + "img/COMBO RAINBOW PURPLE.86acca2.svg";